import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import interfaceFormMeta, { I_InterfaceFormMeta } from "./InterfaceFormMeta";
import lastTransactionFormMeta, { ILastTransactionFormMeta } from "./LastTransactionFormMeta";
import locationFormMeta, { ILocationFormMeta } from "./LocationFormMeta";
import modelFormMeta, { IModelFormMeta } from "./ModelFormMeta";

export interface I_IdentificationFormMeta extends I_InterfaceFormMeta, IModelFormMeta, ILocationFormMeta, ILastTransactionFormMeta {
  
  schema: any;
}

let identificationFormMeta = {} as I_IdentificationFormMeta;

identificationFormMeta = { ...identificationFormMeta, ...interfaceFormMeta, ...modelFormMeta, ...locationFormMeta, ...lastTransactionFormMeta
};

identificationFormMeta.schema = yup.object().shape(getValidationSchema(identificationFormMeta));

export default identificationFormMeta;